
import { Component, Prop, Vue } from 'vue-property-decorator'

interface StatItem {
  key: string
  value: string | number
  label: string
  color: string
  icon: string
}

@Component({
  name: 'NativeAppUsersStats'
})
export default class extends Vue {
  @Prop({ required: true }) loading!: boolean
  @Prop({ required: true }) totalCustomers!: number
  @Prop({ required: true }) nativeUsersCount!: number
  @Prop({ required: true }) recentConnectionsCount!: number

  get stats(): StatItem[] {
    const notConnected = Math.max(this.totalCustomers - this.nativeUsersCount, 0)
    const adoptionRate = this.totalCustomers > 0
      ? `${Math.round((this.nativeUsersCount / this.totalCustomers) * 100)} %`
      : '—'

    return [
      {
        key: 'total',
        value: this.totalCustomers,
        label: this.$t('nativeAppUsers.stats.totalCustomers') as string,
        color: '#409EFF',
        icon: 'el-icon-user'
      },
      {
        key: 'connected',
        value: this.nativeUsersCount,
        label: this.$t('nativeAppUsers.stats.connected') as string,
        color: '#67C23A',
        icon: 'el-icon-mobile-phone'
      },
      {
        key: 'notConnected',
        value: notConnected,
        label: this.$t('nativeAppUsers.stats.notConnected') as string,
        color: '#909399',
        icon: 'el-icon-minus'
      },
      {
        key: 'adoption',
        value: adoptionRate,
        label: this.$t('nativeAppUsers.stats.adoptionRate') as string,
        color: '#b43c7c',
        icon: 'el-icon-pie-chart'
      },
      {
        key: 'recent',
        value: this.recentConnectionsCount,
        label: this.$t('nativeAppUsers.stats.recentConnections') as string,
        color: '#E6A23C',
        icon: 'el-icon-time'
      }
    ]
  }
}
